import { AgentService } from './agent.service';
import { KBService } from './kb.service';

export class AIService {
  constructor(
    public agent: AgentService,
    public kb: KBService
  ) {}
}

export const aiService = new AIService(new AgentService(), new KBService());
